module.exports = __webpack_public_path__ + "img/img_Dwangjing.28a1c6fb.png";